import React from 'react';
import Avatar from '@atlaskit/avatar';
import { useIntl } from '@atlassian/jira-intl';
import type { Author } from '../../types.tsx';
import messages from './messages.tsx';

type UserAvatarProps = {
	author: Author;
};

export const UserAvatar = ({ author }: UserAvatarProps) => {
	const { formatMessage } = useIntl();

	if (!author.profilePicture && author.displayName === 'Unknown') {
		return <Avatar name={formatMessage(messages.unknown)} size="small" />;
	}

	return <Avatar src={author.profilePicture ?? undefined} name={author.displayName} size="small" />;
};
